import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";

import {AuthGuardService} from "../_services";
import {UserListComponent} from "./user/user-list/user-list.component";
import {ShowroomListComponent} from "./showroom/showroom-list/showroom-list.component";
// import { LeadSourceListComponent } from './lead-source-list/lead-source-list.component';
import {WebsiteListComponent} from ".//website/website-list/website-list.component";
import {JobFunctionListComponent} from "./job-function/job-function-list/job-function-list.component";
import {ContactTypeListComponent} from "./contact-type/contact-type-list/contact-type-list.component";
import {ContactSourceListComponent} from "./contact-source/contact-source-list/contact-source-list.component";
import {ProjectStatusListComponent} from "./project-status/project-status-list/project-status-list.component";
import {ProjectMapStepComponent} from "./project-map/project-map-step/project-map-step.component";
import {PermissionListComponent} from "./permission/permission-list/permission-list.component";
import {SettingsComponent} from "./settings/settings/settings.component";
import {ClearDatabaseComponent} from "./settings/clear-database/clear-database.component";
import {ListComponent} from "./calender-event-types/list/list.component";
import {ImportExportComponent} from "./import-export/import-export.component";
import {CommentTypeListComponent} from "./comment-types/comment-type-list/comment-type-list.component";
import {MarketingListsComponent} from "./marketing-lists/marketing-lists/marketing-lists.component";
import {MarketingListEntriesComponent} from "./marketing-lists/marketing-list-entries/marketing-list-entries.component";
import {OneTimeComponent} from "./one-time/one-time.component";
import {SettingsFormComponent} from "./settings/settings-form/settings-form.component";

//Components...

const routes: Routes = [
  {
    path: "user-list",
    component: UserListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "showroom-list",
    component: ShowroomListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "website-list",
    component: WebsiteListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "contact-source-list",
    component: ContactSourceListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "contact-type-list",
    component: ContactTypeListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "job-function-list",
    component: JobFunctionListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "project-status-list",
    component: ProjectStatusListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "project-map-step-list",
    component: ProjectMapStepComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "permission-list",
    component: PermissionListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "settings",
    component: SettingsComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "clear-database",
    component: ClearDatabaseComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "admin/marketing-lists",
    component: MarketingListsComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "marketing-lists",
    component: MarketingListEntriesComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "calender-event-type-list",
    component: ListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "import-export",
    component: ImportExportComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "comment-types",
    component: CommentTypeListComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  },
  {
    path: "one-time",
    component: OneTimeComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  }, //one-time
  {
    path: "settings-form",
    component: SettingsFormComponent,
    data: {
      layoutName: "layoutTwo",
    },
    canActivate: [AuthGuardService],
  }, //one-time
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
